<m-banner
  *ngIf="showBanner"
  class="hero-banner"
  [type]="bannerConfig.type"
  [title]="
    showDownloadResults
      ? bannerConfig.title
      : bannerConfig.titleNoDownloadResults
  "
  [closeable]="!showDownloadResults"
  (closeBanner)="handleClose()">
  <span action *ngIf="showDownloadResults" class="banner-action-v1 block">
    <div class="b1 text-gray-700">
      The new version of MIM enhances your whole portfolio with media mix model
      capabilities and results from your tests. Check out your results below and
      discuss them with your customer success partner.
      <div class="mt-6 flex items-center">
        <a
          class="text-blue-600 no-underline hover:text-blue-500"
          href="https://support.measured.com/article/h62nuemky4-mim-overview"
          target="_blank"
          >Learn more about MIM</a
        >
        <div class="ml-8">
          <m-dropdown
            styleClass="mmm-export-banner-dropdown bg-transparent shadow-none"
            placeholder="Download results"
            [options]="exportOptions"
            [(ngModel)]="exportOption"
            (formControlChange)="onExportChange($event?.value)"
            [preventSelection]="true"
            width="10rem"></m-dropdown>
        </div>
      </div>
    </div>
  </span>
  <div creative class="w-full flex justify-center" *ngIf="showDownloadResults">
    <img src="/assets/images/creative/mim-v1.svg" alt="MIM Banner" />
  </div>

  <span action *ngIf="!showDownloadResults" class="banner-action-v2 block">
    <div class="b1 text-gray-700">
      Your results are now enhanced by the Measured Incrementality Model, which
      is powered by your media mix model. This gives you a full-portfolio view
      of your media spending's effectiveness by triangulating multiple data
      sources.
    </div>
    <div class="mt-6">
      <a
        class="text-blue-600 no-underline hover:text-blue-500 ml-2"
        href="https://support.measured.com/article/h62nuemky4-mim-overview"
        target="_blank"
        >Learn more about MIM</a
      >
    </div>
  </span>
  <div creative class="w-full flex justify-center" *ngIf="!showDownloadResults">
    <img src="/assets/images/creative/mim-v2.svg" alt="MIM Banner" />
  </div>
</m-banner>
